
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.156 9.488a.847.847 0 01.852-.847l1.411.004a.849.849 0 01.85.85v5.338c.158-.047.362-.098.586-.15a.707.707 0 00.545-.689V7.373a.849.849 0 01.849-.85h1.416a.85.85 0 01.848.85v6.146s.355-.144.7-.29a.709.709 0 00.432-.651V5.25a.849.849 0 01.849-.85h1.414a.849.849 0 01.848.85v6.033c1.227-.889 2.47-1.958 3.456-3.243a1.424 1.424 0 00.217-1.33 9.992 9.992 0 10-18.102 8.256 1.263 1.263 0 001.206.625c.267-.024.6-.057.997-.104a.707.707 0 00.627-.701V9.488","fill":"#12161C"}}),_c('path',{attrs:{"d":"M4.126 18.05a9.994 9.994 0 0015.848-8.768C16.322 14.73 9.579 17.275 4.126 18.05z","fill":"#F0B90B"}})])
          )
        }
      }
    